import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import {Swiper, SwiperSlide} from "swiper/react";
import { Navigation, Pagination, Scrollbar, A11y, EffectFade } from 'swiper/modules';
import 'swiper/css/bundle'
import 'swiper/css'
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';
import "../../styles/Material.css"
import TextArea from 'antd/es/input/TextArea';
import { Button, CircularProgress, IconButton, Rating, Skeleton } from '@mui/material';
import RateReviewIcon from '@mui/icons-material/RateReview';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { Input } from 'antd';
import HdrStrongIcon from '@mui/icons-material/HdrStrong';
import Purchase from './Purchase';

export default function EachMaterial({propsData}) {
  const location = useLocation()
  const [routes,setRoutes]=useState(location.pathname.split("/"))
  let navigate=useNavigate()
  let [Material,GetMaterial]=useState({})
  let [error,setError]=useState(false)

  useEffect(()=>{
    setError(true)
    setRoutes(location.pathname.split("/"))
    let currentLocation=location.pathname.split("/")
   // //console.log(location.pathname.split("/"));
    
    axios.get(`${process.env.REACT_APP_URL}/api/material/GetMaterial/${currentLocation[2]}`, //proxy uri
    {
       headers: {
          authorization:`Bearer ${ propsData.userData?.token }`,
          'Content-Type': 'application/json'
       } 
    })
    .then(res=>{
      //console.log(res.data);
      GetMaterial(res.data)
      setError(false)
    })
    .catch(error=>{
      //console.log(error);
    })
},[propsData.equilizer,location])


function formatNumberWithCommas(number) {
  const numberString = number?.toString();
  const parts = numberString.split('.');
  const formattedInteger = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const formattedNumber = parts.length > 1 ? formattedInteger + '.' + parts[1] : formattedInteger;

  return formattedNumber;
}

let [AllReviews,GetAllReviews]=useState([])
let [AveregaRate,GetAveregaRate]=useState(0)
let [LoadReview,HandleLoadReview]=useState(false)

useEffect(()=>{
  HandleLoadReview(true)
  let currentLocation=location.pathname.split("/")
  axios.get(`${process.env.REACT_APP_URL}/api/material/GetMaterialReviews/${currentLocation[2]}`, //proxy uri
  {
     headers: {
        authorization:`Bearer ${ propsData.userData?.token }`,
        'Content-Type': 'application/json'
     } 
  })

  .then(res=>{
    ////console.log(res.data);
    HandleLoadReview(false)
    GetAllReviews(res.data.reviews)
    GetAveregaRate(res.data.rate||0)
    if(res.data.length>20){
        GetAllReviews(res.data.reviews.slice(0,20))
    }
  })
  .catch(error=>{
    // //console.log(error);
  })
},[propsData.equilizer,location])

let [seeDetailsPage,GetSeeDetailsPage]=useState(false)


let[categoryMaterials,handleCategoryMaterials]=useState([])
let [errorMaterials,setErrorErrorMaterials]=useState(false)

useEffect(()=>{
  setErrorErrorMaterials(true)
  axios.get(`${process.env.REACT_APP_URL}/api/material/GetAllMaterials`, //proxy uri
  {
     headers: {
        authorization:`Bearer ${ propsData.userData?.token }`,
        'Content-Type': 'application/json'
     } 
  })
  .then(res=>{
    //console.log(res.data);
    handleCategoryMaterials(res.data)
    setErrorErrorMaterials(false)
  })
  .catch(error=>{
    //console.log(error);
  })
},[propsData.equilizer,location])

let sampleErrorMaterial=[1,2,3,4,5]

let[configPage,openConfigPage]=useState(false)
let [name,setName]=useState(Material?.name)
let [price,setPrice]=useState(Material?.price)
let [description,setDescription]=useState(Material?.description)
const [requiredKeys, setRequiredKeys] = useState({});

useEffect(() => {
  if (Material?.properties?.length>0) {
    setRequiredKeys((prevState) => {
      const updatedState = { };
      for (const item of Material?.properties) {
        updatedState[item.key] = item.value;
      }
      return updatedState;
    });
  }
}, [Material?.properties]);

useEffect(()=>{
  setName(Material?.name)
  setPrice(Material?.price)
  setDescription(Material?.description)
},[Material])

let [deletePage,handleDeletePage]=useState(false)
let[disablePostButton,handlDisableButton]=useState(true)
useEffect(()=>{
    let keysWithNonEmptyValues = Object.keys(requiredKeys).filter(key => requiredKeys[key] === "");
    if (keysWithNonEmptyValues.length > 0) {
    handlDisableButton(true)
    } else {
    handlDisableButton(false)
    }
},[requiredKeys])

let [errorDelete,setErrorDelete]=useState(false)
let [loadDelete,setLoadDelete]=useState(false)

const DeleteMaterial=()=>{
  setLoadDelete(true)
  axios.delete(`${process.env.REACT_APP_URL}/api/material/RemoveMaterial/${Material?._id}`,
    {
      headers: {
          authorization:`Bearer ${ propsData.userData?.token }`,
          'Content-Type': 'application/json'
      } 
    })
    .then(res=>{
      //console.log(res.data);
      propsData.setEquilizer(propsData.equilizer+2)
     navigate("/materials")
    })
    .catch(error=>{
      setLoadDelete(false)
      setErrorDelete(error?.response?.data?.error||"Check internate connecton then try again")
      setTimeout(()=>{
        setErrorDelete("")
      },7000)
      //console.log(error);
    })
}

let [errorUpdate,setErrorUpdate]=useState(false)
let [loadUpdate,setLoadUpdate]=useState(false)

const updateValues=()=>{
    let data={
      name:name,
      price:price,
      description:description,
      requiredKeys:JSON.stringify(requiredKeys),
      materialId:Material?._id
    }
    //console.log(data);
    setLoadUpdate(true)
    axios.put(`${process.env.REACT_APP_URL}/api/material/UpdateMaterial`,data,
    {
      headers: {
          authorization:`Bearer ${ propsData.userData?.token }`,
          'Content-Type': 'application/json'
      } 
    })
    .then(res=>{
      //console.log(res.data);
      setLoadUpdate(false)
      propsData.setEquilizer(propsData.equilizer+2)
      openConfigPage(false)
    })
    .catch(error=>{
      setLoadUpdate(false)
      setErrorUpdate(error?.response?.data?.error||"Check internate connecton then try again")
      setTimeout(()=>{
        setErrorUpdate("")
      },7000)
      //console.log(error);
    })

}


let [AddedToCart,HandleAddedToCart]=useState(propsData.userData?.data?.cart?.includes(Material?._id))
let [LoadAddedToCart,HandleLoadAddedToCart]=useState(false)
////console.log(propsData.userData?.data?.cart?.includes(Material?._id),AddedToCart);

useEffect(()=>{
  HandleAddedToCart(propsData.userData?.data?.cart?.includes(Material?._id))
},[Material])

const AddToCart=()=>{
  HandleLoadAddedToCart(true)
  let data={
    materialId:Material?._id
  }
  axios.put(`${process.env.REACT_APP_URL}/api/user/AddRemoveMaterialCart`,data, //proxy uri
  {
     headers: {
        authorization:`Bearer ${ propsData.userData?.token }`,
        'Content-Type': 'application/json'
     } 
  })
  .then(res=>{
    //console.log(res.data);
   // HandleLoadAddedToCart(false)
   HandleAddedToCart(res.data.msg==="Removed"?false:true)
  })
  .catch(error=>{
   //console.log(error);
  })

}

let [openPurchase,handleOpenPurchase]=useState(false)
return (
    <div className='singleMaterialContainer'>
        <div className='singleMaterialContainerTop'>
           <div className='singleMaterialContainerTopImageName'>
                <div className='singleMaterialContainerTopImage'>{Material?.images?.length>0&&<Slider slides={Material.images}/>}</div>
                <div className='singleMaterialContainerTopName'>{Material?.name}</div>
                <div  className='singleMaterialContainerShop'>
                    From <Link to={`/shop/${Material?.category?.shop?._id}`} style={{color:"inherit",paddingRight:"5px"}}>{Material?.category?.shop?.shope_name}</Link>, <Link to={`/categories/${Material?.category?._id}`} style={{color:"inherit"}}>{Material?.category?.name}</Link> Category
                    <div style={{marginTop:"15px"}}><IconButton onClick={AddToCart}><ShoppingCartIcon style={{color:AddedToCart?"goldenrod":"rgb(100, 60, 0)"}}/></IconButton></div>  

                </div>

                <div className='singleMaterialContainerShopButtons'>
                   
                    {(Material?.createdBy===propsData?.userData?.data?._id||Material?.category?.shop?.ownedBy===propsData?.userData?.data?._id) &&
                    <div>
                      <Button onClick={()=>openConfigPage(!configPage)}>Configure</Button>
                    </div>}
                   
                    <div><Button onClick={()=>handleOpenPurchase(!openPurchase)}>Purchase</Button></div>

                </div>

                <div className='singleMaterialContainerTopData'>
                    
                    <div className='singleMaterialContainerTopDataEach'>
                          <div className='singleMaterialContainerTopDataEachTitle'><HdrStrongIcon  style={{fontSize:"12px",color:"red"}}/> price</div>
                          <div className='singleMaterialContainerTopDataEachValue'>{formatNumberWithCommas(Material?.price||0)}</div>
                      </div>  
                      
                      <>
                          {Material?.properties?.map((e,index)=>{
                            return <EachProperties item={e} key={index} />
                          })}
                      </>

                      <div className='singleMaterialContainerTopDataEach'>
                          <div className='singleMaterialContainerTopDataEachTitle'><HdrStrongIcon style={{fontSize:"12px",color:"red"}}/> description</div>
                          <div className='singleMaterialContainerTopDataEachValue'>{Material?.description}</div>
                      </div> 
                    
                  </div>
       
          </div>

          <div className='singleMaterialContainerReviews'>
                  <div className="singleMaterialContainerRating">
                                    <div style={{fontSize:"40px",fontWeight:700}}> {Math.round(AveregaRate * 10)/10} </div>
                                    <div><Rating name="half-rating-read" value={Math.round(AveregaRate * 10)/10} precision={0.5} readOnly /></div>
                     </div>
                      <div  className='singleMaterialContainerReviewsAll'>
                               {AllReviews?.map(e=>{
                                return  <div  className="singleMaterialContainerReviewsEach"> 
                                          <img src={e?.By.profile?.fileUrl} width={30} height={30} style={{borderRadius:"50%"}}/>
                                      </div>
                               })}

                            {AllReviews?.length>0&&<div className="singleMaterialContainerReviewsAllSeeMore"> <Button onClick={()=>GetSeeDetailsPage(!seeDetailsPage)}>See Details {AllReviews.length}</Button></div>}
                            {AllReviews?.length===0&&<div>No Reviews Added</div>}
                             
                      </div>
                      <AddReviews propsData={propsData} AllReviews={AllReviews}/>
             </div>    
                  
        </div> 

        {seeDetailsPage&&<GetAllReviewsData GetSeeDetailsPage={GetSeeDetailsPage} seeDetailsPage={seeDetailsPage} route={routes[2]} propsData={propsData}/>
                    }       

        <div className='singleMaterialContainerBody'>
           <div className='singleMaterialContainerBodyTitle'>Suggested materials</div>
           <div className='singleMaterialContainerBodyAll'>
           {!errorMaterials?
                  <div className='singleCategoryMaterialsAll'>
                      {categoryMaterials?.map((e,index)=>{
                           if(e._id===Material._id){
                            return null;
                           }
                           return <EachMaterials propsData={propsData} item={e} key={index}/>
                      })}
                  </div>:
                  <div className='singleCategoryMaterialsAll'>
                       {sampleErrorMaterial.map(e=>{
                        return <Skeleton  variant="rounded"  width={210} height={150}  />
                       })}
                  </div>
                }
            </div> 
         </div>
         
         {configPage&&
         <div className="singleMaterialConfigPage">
            <div className="singleMaterialConfigPageBox">
                <div><IconButton onClick={()=>openConfigPage(false)}><CloseIcon style={{color:"red"}}/></IconButton></div>
                <div className="singleMaterialConfigPageEdit">
                   <div className="singleMaterialConfigPageEditTitle">Edit Material</div>
                   <div className="singleMaterialConfigPageEditForm">
                     
                      <div className="singleMaterialConfigPageEditFormEach">
                            <div className="singleMaterialConfigPageEditFormEachTitle">Name</div>
                            <div className="singleMaterialConfigPageEditFormEachValue"><Input value={name} onChange={(e)=>setName(e.target.value)}/></div>
                      </div>

                        <div className="singleMaterialConfigPageEditFormEach">
                            <div className="singleMaterialConfigPageEditFormEachTitle">Price</div>
                            <div className="singleMaterialConfigPageEditFormEachValue"><Input value={price} onChange={(e)=>setPrice(e.target.value)}/></div>
                        </div>

                        <div className="singleMaterialConfigPageEditFormEach">
                            <div className="singleMaterialConfigPageEditFormEachTitle">Description</div>
                            <div className="singleMaterialConfigPageEditFormEachValue">
                              <TextArea 
                                  autoFocus={true}
                                  autoSize={{
                                  minRows:2,
                                  maxRows: 3,
                                  }} 
                                 value={description} onChange={(e)=>setDescription(e.target.value)}/></div>
                        </div>

                        {Object.keys(requiredKeys).map((key) => {
                          return (
                            <div className='singleMaterialConfigPageEditFormEach' key={key}>
                              <div className='singleMaterialConfigPageEditFormEachTitle'>{key}</div>
                              <div className='singleMaterialConfigPageEditFormEachValue'>
                                <Input value={requiredKeys[key]} onChange={(e) => setRequiredKeys((prevState) => ({ ...prevState, [key]: e.target.value }))} />
                              </div>
                            </div>
                          );
                        })}

                        {errorUpdate&&<div style={{color:"red",margin:"5px"}}>{errorUpdate}</div>}
                          <div className='singleMaterialConfigPageButton' >
                            {loadUpdate?<CircularProgress size={30}/>:<Button  disabled={disablePostButton||!name||!price||!description} onClick={updateValues}>Update</Button>}
                          </div>

                    </div>      
                </div>

                 <div className='singleMaterialConfigPageDelete'>
                    <p>Deleting material will Delete the material permanently, and you won't get it again</p>
                    {deletePage?
                    <>
                       {errorDelete&&<div style={{color:"red",margin:"8px"}}>{errorDelete}</div>}

                      {loadDelete?
                         <div  style={{textAlign:"center",margin:"6px"}}><CircularProgress size={30}/></div>
                       :
                      <div style={{display:"flex",justifyContent:"space-around",alignItems:"center"}}>
                          <div className='singleMaterialConfigPageDeleteButton'><Button onClick={DeleteMaterial}>Go</Button></div>
                          <div className='singleMaterialConfigPageDeleteCancel'><Button onClick={()=>handleDeletePage(false)}>Cancel</Button></div>
                      </div>
                      }
                    
                    </>
                      :
                    <div className='singleMaterialConfigPageDeleteButton'><Button onClick={()=>handleDeletePage(!deletePage)}>Delete</Button></div>}

                  </div>
             
            </div>
         </div>
         }

          {/*openPurchase&&<Purchase materiald={Material._id} /> */}
                
    </div>
  )
}

const Slider = ({ slides }) => {
  return (
    <Swiper
      modules={[Navigation, Pagination, Scrollbar, A11y,EffectFade]}
      spaceBetween={10}
      slidesPerView={1}
      navigation
      pagination={{ clickable: true }}
      style={{ boxShadow: "none",height:"100%" }}
    >
      {slides.map((slide,index) => (
        <SwiperSlide key={index} >
          <img style={{borderRadius:"20px 20px 0 0",objectFit:"cover"}} src={`${slide.fileUrl}`} className='swiper-image' height={"100%"} width={"100%"} alt={"slider.pic"}/>
        </SwiperSlide>
      ))}
    </Swiper>
  )

}

const EachProperties=({item})=>{

  return(
    <div className='singleMaterialContainerTopDataEach'>
    <div className='singleMaterialContainerTopDataEachTitle'><HdrStrongIcon style={{fontSize:"12px",color:"red"}}/> {item.key}</div>
    <div className='singleMaterialContainerTopDataEachValue'>{item.value}</div>
</div>  
  )
}

const AddReviews=({propsData,AllReviews})=>{
  
  let [loading,setLoading]=useState(false)
  let [error,GetError]=useState(false)
  const [reviewText,handleReviewText]=useState("")
  const [reviewRate,handleReviewRate]=useState(0)
  const location = useLocation()
  const [routes,setRoutes]=useState(location.pathname.split("/"))

  const AddReviews=()=>{
      setLoading(true)
      if(reviewRate===null){
           setLoading(false)

          return;
      }
      let value={
          reviewer:propsData.currentShope,
          materialId:routes[2],
          text:reviewText,
          rate:reviewRate,
      }  

      axios.put(`${process.env.REACT_APP_URL}/api/material/AddReviews`,value, //proxy uri
      {
         headers: {
            authorization:`Bearer ${ propsData.userData?.token }`,
            'Content-Type': 'application/json'
         } 
      })
      .then(res=>{
        //////console.log(res.data);
        setLoading(false)
        handleReviewRate("")
        handleReviewText("")
        propsData.setEquilizer(propsData.equilizer+3)
      })
      .catch(error=>{
          setLoading(false)
          GetError("Try, again later")
          setTimeout(()=>{
              GetError("") 
          },6000)

        //console.log(error);
      })
  }

  let userAlreadyeviewd=AllReviews?.filter(e=>{
    return e?.By?._id?.toString()===propsData.currentShope
 })
 let [showAddReview,handleShowAddReview]=useState(false)

  return(
  <div style={{display:"flex",justifyContent:"flex-start",marginTop:"10px"}}>
    {(userAlreadyeviewd?.length===0||!userAlreadyeviewd)&&<div><IconButton onClick={()=>handleShowAddReview(!showAddReview)}><RateReviewIcon style={{color:"rgba(255,115,15,1)"}}/></IconButton></div>}                     
      {((userAlreadyeviewd?.length===0||!userAlreadyeviewd)&&showAddReview)&&
        <div className="reviewsEachAdd">
            <div  className="reviewsEachAdd-text">
                <div className="reviewsEachAdd-input">
                    <TextArea   
                    autoFocus={true}
                        autoSize={{
                        minRows:1,
                        maxRows: 2,
                        }} placeholder='Review'
                        value={reviewText}  onChange={(e)=>handleReviewText(e.target.value)}/>

                </div>
                {reviewText.length>0&&<div>{loading?<CircularProgress size={20}/>:<Button onClick={AddReviews}>Submit</Button>}</div>}
            </div>
          {reviewText.length>0&&<div className="reviewsEachAdd-rate"> 
                <Rating
                        name="simple-controlled"
                        value={reviewRate}
                        onChange={(event, newValue) => {
                            handleReviewRate(newValue);
                        }}
                    />
            </div> }
            {error&&<div style={{color:"red",fontSize:"12px"}}>{error}</div>}
        </div>
     }
</div>
  )
}

const GetAllReviewsData=({propsData,route,GetSeeDetailsPage,seeDetailsPage})=>{
    
  let [AllReviews,GetAllReviews]=useState([])
  let [LoadReview,HandleLoadReview]=useState(false)
 //console.log(route);

  useEffect(()=>{
    HandleLoadReview(true)
    axios.get(`${process.env.REACT_APP_URL}/api/material/GetMaterialReviews/${route}`, //proxy uri
    {
       headers: {
          authorization:`Bearer ${ propsData.userData?.token }`,
          'Content-Type': 'application/json'
       } 
    })

    .then(res=>{
      ////console.log(res.data);
      HandleLoadReview(false)
      GetAllReviews(res.data.reviews)
  
    })
    .catch(error=>{
       ////console.log(error);
    })
  },[propsData.equilizer])


  //console.log(AllReviews);
  let [makeEdit,hanldeMakeEdit]=useState(false)
  return(
  <div className="reviews-container">
      <div className="reviews-body">
           <div><IconButton onClick={()=>GetSeeDetailsPage(!seeDetailsPage)}><CloseIcon style={{color:"red"}}/></IconButton></div>
          <h2>Reviews</h2>
          {LoadReview&&<div style={{display:"flex",justifyContent:"center",alignItems:"center"}}><CircularProgress /></div>}
          <div  className="reviews-body-All">
              {AllReviews?.map(e=>{

                  return <EachReviews route={route} e={e} propsData={propsData} key={e?._id}/>
              })}
          </div>

      </div>
 </div>)
}

const EachReviews=({propsData,e,route})=>{
  let [makeEdit,hanldeMakeEdit]=useState(false)
  let [reviewText,handleReviewText]=useState(e?.text)
  const [reviewRate,handleReviewRate]=useState(e?.rate)

  let [loading,setLoading]=useState(false)
  let [error,GetError]=useState(false)

//   ////console.log(propsData.currentShope,e.By._id);
 const updateReview=()=>{
  setLoading(true)
  if(reviewRate===null){
      return;
  }
  let value={
      reviewId:e?._id,
      reviewer:propsData.currentShope,
      text:reviewText,
      rate:reviewRate,
  }  

  axios.put(`${process.env.REACT_APP_URL}/api/shope/UpdateReview`,value, //proxy uri
      {
      headers: {
          authorization:`Bearer ${ propsData.userData?.token }`,
          'Content-Type': 'application/json'
      } 
      })
  .then(res=>{
    //////console.log(res.data);
    setLoading(false)
    hanldeMakeEdit(false)
    propsData.setEquilizer(propsData.equilizer+3)
  })
  .catch(error=>{
      setLoading(false)
      GetError("Try, again later")
      setTimeout(()=>{
          GetError("") 
      },3000)
    ////console.log(error);

  })
 }

  return(
              <div className={`reviews-body-each ${propsData.currentShope===e.By._id.toString()&&"reviews-body-each-mine"}`}>
                 <Link style={{textDecoration:"none",color:"inherit"}} to={`/profile/shop/${e?.By?._id}`}>
                      <div className="reviews-body-each-profile">
                          <div><img src={e.By.profile.fileUrl}  style={{borderRadius:"50%"}} width={50} height={50}/></div>
                          <div>{e.By.shope_name}</div>
                      </div>
                  </Link>
                  <div className="reviews-body-each-review">
                      <div className="reviews-body-each-review-rate">
                      <Rating name={makeEdit?"simple-controlled":"read-only"}
                          value={reviewRate}
                          onChange={(event, newValue) => {
                              handleReviewRate(newValue);
                          }}
                          readOnly={!makeEdit}
                          />
                      </div>
                      <div className="reviews-body-each-review-text">
                      {makeEdit? 
                          <TextArea   
                              autoFocus={true}
                                  autoSize={{
                                  minRows:1,
                                  maxRows: 2,
                                  }} placeholder='Review'
                                  value={reviewText}  onChange={(e)=>handleReviewText(e.target.value)}/>
                          :
                          <div>{reviewText}</div>
                          }

                      </div>
                  </div>

                  {propsData.currentShope===e.By._id.toString()&&<div>
                      {makeEdit?
                      <>
                          {loading?
                          <div style={{textAlign:"center",marginTop:"20px"}}><CircularProgress size={23}/></div>
                          :
                          <div className="reviews-body-each-review-update">
                              <div><Button onClick={updateReview}>Update</Button></div>
                              <div><Button onClick={()=>hanldeMakeEdit(!makeEdit)}>Cancel</Button></div>
                          </div>
                          }
                      </> 
                          :
                          <div style={{textAlign:"end"}}><IconButton onClick={()=>hanldeMakeEdit(!makeEdit)}><EditIcon/></IconButton> </div>}
                  
                  </div>}
          </div>
  )
}


const EachMaterials=({item,propsData})=>{

  const sum = item.reviews.reduce((acc, num) => acc + num.rate, 0);
  let AveregaRate = sum / item.reviews.length;
  
  function formatNumberWithCommas(number) {
    // Convert the number to a string
    const numberString = number.toString();
  
    // Split the string into integer and decimal parts (if any)
    const parts = numberString.split('.');
  
    // Format the integer part with commas
    const formattedInteger = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  
    // Combine the formatted integer with the decimal part (if any)
    const formattedNumber = parts.length > 1 ? formattedInteger + '.' + parts[1] : formattedInteger;
  
    return formattedNumber;
  }

  let [AddedToCart,HandleAddedToCart]=useState(propsData.userData?.data?.cart?.includes(item?._id))
  let [LoadAddedToCart,HandleLoadAddedToCart]=useState(false)

  const AddToCart=()=>{
    HandleLoadAddedToCart(true)
    let data={
      materialId:item._id
    }
    axios.put(`${process.env.REACT_APP_URL}/api/user/AddRemoveMaterialCart`,data, //proxy uri
    {
       headers: {
          authorization:`Bearer ${ propsData.userData?.token }`,
          'Content-Type': 'application/json'
       } 
    })
    .then(res=>{
      //console.log(res.data);
     // HandleLoadAddedToCart(false)
     HandleAddedToCart(res.data.msg==="Removed"?false:true)
    })
    .catch(error=>{
  //  console.log(error);
    })

  }

  return(
    <div 
      className='singleCategoryMaterialsEach singleMaterialMinimized'
      >
               <div className='singleCategoryMaterialsEachImage'>
                    <img src={`${item.images[0].fileUrl}`} width={"100%"} alt={"slider.pic"}/>
                </div>
                <div style={{  padding: "0px 30px 0px 30px"}}>
                    <Link   style={{color:"inherit",textDecoration:"none"}} to={`/materials/${item._id}`}><h3>{item?.name?.length>10?`${item?.name.slice(0,10)}...`:item.name}</h3> </Link>
                    <div className='singleCategoryMaterialsEachImageData'>
                        <div className='singleCategoryMaterialsEachImageDataEachValue'>{formatNumberWithCommas(item.price)}</div>                      
                        <div className="singleCategoryMaterialsEachImageDataRating">
                            <div><Rating name="half-rating-read" value={Math.round(AveregaRate * 10)/10} precision={0.5} readOnly /></div>
                             <div><IconButton onClick={AddToCart}><ShoppingCartIcon style={{color:AddedToCart?"goldenrod":"rgb(100, 60, 0)"}}/></IconButton></div>  
                          </div>

                    </div>
                
                </div>
            
  </div>
  )
}

